<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>角色管理</el-breadcrumb-item>
      <el-breadcrumb-item>角色列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-row :gutter="0">
        <el-col :span="9">
          <el-input placeholder="请输入查询内容" v-model="queryInfo.query" class="input-with-select" clearable
            style="width:300px;" @clear="getJueseList" @change="getJueseList">
            <el-button slot="append" icon="el-icon-search" @click="getJueseList"></el-button>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="juese_add_open" v-if="true">添加角色</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="0" class="el_row_two">
        <el-col :span="24">
          <el-table :data="jueseList" style="width: 100%" border stripe>
            <!-- <el-table-column type="index" label="序号" width="80"></el-table-column> -->
            <el-table-column type="expand">
              <template slot-scope="scope">
                <!-- <pre> {{scope.row}}</pre> -->
                <el-row :class="['bdbottom', i1 === 0 ? 'bdtop' : '', 'vcenter']"
                  v-for="( item1, i1 ) in scope.row.children_selected" :key="item1.uid">
                  <el-col :span="4">
                    <el-tag type>{{ item1.xingwei_name }}</el-tag>
                    <i class="el-icon-caret-right" @click="children_isShow()"></i>
                  </el-col>
                  <el-col :span="20">
                    <el-row :class="[i2 == 0 ? '' : 'bdtop']" v-for="( item2, i2 ) in item1.children_selected"
                      :key="item2.xingwei_uid">
                      <el-col :span="6">
                        <el-tag type="success" closable
                          @close="removeRightById(item2.quanxian_uid)">{{ item2.xingwei_name }}</el-tag>
                      </el-col>
                      <el-col :span="18"></el-col>
                    </el-row>
                  </el-col>
                </el-row>
              </template>
            </el-table-column>
            <el-table-column prop="uid" label=" 序号" width="80"></el-table-column>
            <el-table-column prop="juese_name" label="名称"></el-table-column>
            <el-table-column   label="角色类型">
              <template slot-scope="scope">
                <span v-if="scope.row.juese_type == 1">门店</span>
                <span v-if="scope.row.juese_type == 2">管理员</span>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template v-slot="scope">
                <el-tooltip class="item" effect="dark" content="修改" placement="top" :enterable="false">
                  <el-button type="primary" icon="el-icon-edit" @click="showEditDialog(scope.row.uid)" circle
                    size="mini" v-if="false"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark"
                  v-show="(scope.row.juese_name !== '管理员') && (scope.row.juese_name !== '门店用户')" content="删除"
                  placement="top" :enterable="false" >
                  <el-button type="danger" icon="el-icon-delete" circle size="mini"
                    @click="deleteForm(scope.row.uid)" v-if="false"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="设置" placement="top" :enterable="false">
                  <el-button type="success" icon="el-icon-orange" @click="showRightDialogVisble(scope.row)" circle
                    size="mini"></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>

      <!-- 添加角色部分 -->
      <el-dialog title="添加角色" :visible.sync="addDialogVisible" width="50%" @close="addDoalogClosed">
        <el-form ref="addFormRef" :model="addForm" :rules="addFormRules" label-width="100px">
          <el-form-item label="角色编号" prop="juese_bianhao">
            <el-input v-model="addForm.juese_bianhao"></el-input>
          </el-form-item>
          <el-form-item label="选择类型" prop="juese_uid">
            <el-select v-model="addForm.juese_type" placeholder="选择类型">
              <el-option v-for="item in jueseTypeList" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="角色名称" prop="juese_name">
            <el-input v-model="addForm.juese_name"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="addjuese" :disabled="add_isDisable">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 修改角色信息 -->
      <el-dialog title="修改角色信息" :visible.sync="editDialogVisible" width="50%" @close="editDoalogClosed">
        <el-form ref="editFormRef" :model="addForm" :rules="editFormRules" label-width="100px">
          <el-form-item label="角色编号" prop="juese_uid">
            <el-input v-model="editForm.juese_uid"></el-input>
          </el-form-item>
          <el-form-item label="选择类型" prop="juese_uid">
            <el-select v-model="editForm.juese_type" placeholder="选择类型">
              <el-option v-for="item in jueseTypeList" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
         
          <el-form-item label="角色名称" prop="juese_name">
            <el-input v-model="editForm.juese_name"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="updatejuese">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog title="权限设置" :visible.sync="setRightVisble" width="50%" @close="setRightDialogClosed">
        <el-tree :data="rightsData" :props="rightsProps" ref="treeRef" default-expand-all show-checkbox
          node-key="quanxian_uid" :default-checked-keys="defkeys"></el-tree>
        <span slot="footer" class="dialog-footer">
          <el-button @click="setRightVisble = false">关闭窗口</el-button>
          <el-button type="primary" @click="rightsUpdate">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
export default {
  props: ['juese_type'], // juese_type 角色类型 1 门店 2 管理员
  data() {
    return {
      
      // 获取用户列表参数
      queryInfo: {
        C_type: 'juese_list',
        query: '',
        pageNum: 1,
        pageSize: 1000,
        type: this.juese_type
        // 最多1000个角色，此处不再分页，在添加的时候做限定，生成编号的时候进行检测
      },
      jueseList: [],
      //  recordCount: 0,
      jueseTypeList: this.juese_type === '1' ? [
      {
        value: 1,
        label: '门店',
        disabled: true
      }] : [
      {
        value: 2,
        label: '管理员',
        disabled: true
      }],
      total: 0,
      addDialogVisible: false,
      editDialogVisible: false,
      children_show_yn: false,
      setRightVisble: false,
      //  添加表单数据项
      // rightsData 用于权限设置dialog 中 读取保存数据
      addForm: {
        C_type: 'juese_add',
        juese_bianhao: '',
        juese_name: '',
        juese_type: ''
      },
      mendianTypeList: this.juese_type === '1' ? [
      {
        value: 1,
        label: '系统管理类型',
        disabled: true
      }] : [
      {
        value: 1,
        label: '直营门店',
        disabled: true
      }, {
        value: 2,
        label: '特许加盟门店',
        disabled: true
      }, 
      {
        value: 3,
        label: '亿业联盟店',
        disabled: true
      }
    ],
      // 绑定数据  //tree 显示规则
      rightsData: [],
      rightsProps: {
        children: 'children_all',
        label: 'xingwei_name'
      },
      // 当前角色的row 操作uid
      juse_right_uid: '',
      defkeys: [], // 递归数据获取，用于tree显示
      // 用于修改数据绑定
      editForm: {},
      add_isDisable: false,
      // 表单规则项
      addFormRules: {
        juese_name: [
          { required: true, message: '请输入角色名称', trigger: 'blur' },
          { min: 3, max: 10, message: '必须3到10位字符 ', trigger: 'blur' }
        ],
        juese_admin: [
          { required: true, message: '请输入角色管理员', trigger: 'blur' },
          { min: 3, max: 10, message: '必须3到10位字符', trigger: 'blur' }
        ],
        juese_mob: [
          { required: true, message: '请输入管理员手机号码', trigger: 'blur' },
          { min: 11, max: 11, message: '必须是11位 ', trigger: 'blur' }
        ]
      },
      editFormRules: {}
    };
  },
  created() {
    this.getJueseList();
  },
  methods: {
    // 递交权限数据
    async rightsUpdate() {
      const keys = [
        ...this.$refs.treeRef.getCheckedKeys()
        // ...this.$refs.treeRef.getHalfCheckedKeys()
      ];
      const idStr = keys.join(',');
      // console.log(this.$refs.treeRef.getCheckedKeys())
      const { data: res } = await this.$http.post('api', {
        C_type: 'juese_right_update',
        juese_uid: this.juse_right_uid,
        right_str: idStr
      });
      if (JSON.parse(res.data)[0].status !== 200) {
        this.$message.error('操作失败');
        return;
      }
      this.$message.success('设置成功');
      this.setRightVisble = false;
      this.getJueseList();
    },
    // 清除tree显示的数组
    setRightDialogClosed() {
      this.rightsData = [];
      this.defkeys = [];
    },
    // 递归函数读取数组数据保存到 defkeys 用于树结构显示
    getLeafKeys(node, arr) {
      // node.forEach(item => console.log(item))
      node.forEach(item => {
        if (item.children_selected) {
          item.children_selected.forEach(item => {
            if (item.children_selected) {
              item.children_selected.forEach(item2 => {
                if (item2.quanxian_uid) arr.push(item2.quanxian_uid);
              })
            }
          });
        }
      });
    },
    showRightDialogVisble(data) {
      //  console.log(data)
      this.juse_right_uid = data.uid;
      // 用于绑定组件显示
      this.rightsData = data.children_all;
     // console.log(data)
      // console.log('shibie')
      // 此处为所有选中的项目数据数组
      this.getLeafKeys(data.children_selected, this.defkeys);
      //  this.getLeafKeys(data.children_all, this.defkeys)
      console.log('children_selected', data.children_selected);
        console.log('defkeys', this.defkeys);
      this.setRightVisble = true;
    },
    children_isShow() {
      this.children_show_yn = !this.children_show_yn;
    },
    async getJueseList() {
      const { data: res } = await this.$http.get('get_api', {
        params: this.queryInfo
      });
      this.jueseList = JSON.parse(res.data)[0].data_list;
       console.log('juese_list', JSON.parse(res.data)[0].data_list);
    },
    //  分页第一项下拉触发

    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getJueseList();
    },
    // 选择页数触发
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage;
    },
    addDoalogClosed() {
      this.$refs.addFormRef.resetFields();
    },

    async juese_add_open() {
      const { data: res } = await this.$http.get('get_api', {
        params: { C_type: 'get_bianhao', C_table_type: 1 }
      });

      // console.log(JSON.parse(res.data)[0].bianhao_s)
      this.addForm.juese_bianhao = JSON.parse(res.data)[0].bianhao_s;
      // this.total = JSON.parse(res.data)[0].total;
      this.addDialogVisible = true;
    },
    async addjuese() {
      this.$refs.addFormRef.validate(async valid => {
        if (!valid) return 1;
        this.add_isDisable = true
        setTimeout(() => {
          this.add_isDisable = false // 点击一次时隔两秒后才能再次点击
        }, 2000)
        // console.log(this.addForm)
        const { data: res } = await this.$http.post('api', this.addForm);
        // console.log(JSON.parse(res.data)[0].status);
        if (JSON.parse(res.data)[0].status !== 200) {
          this.$message.error('添加失败');
          return;
        }
        this.getJueseList();
        this.$message.success('添加成功');
        this.addDialogVisible = false;
      });
    },
    showEditDialog(uid) {
      this.editDialogVisible = true;
      this.jueseInfo(uid);
    },
    editDoalogClosed() {
      this.$refs.editFormRef.resetFields();
    },

    async jueseInfo(uid) {
      const { data: res } = await this.$http.get('get_api', {
        params: { C_table_name: 'juese_info', uid: uid, C_type: 'get_info' }
      });
      // console.log(JSON.parse(res.data))

      if (JSON.parse(res.data)[0].status !== 200) {
        return this.$message.error('读取失败');
      }

      this.editForm = JSON.parse(res.data)[0].data[0];
      // console.log(this.editForm)
    },
    async jueseRight(uid) {
      const { data: res } = await this.$http.get('get_api', {
        params: { C_table_name: 'juese_info', uid: uid, C_type: 'get_info' }
      });
      // console.log(JSON.parse(res.data))

      if (JSON.parse(res.data)[0].status !== 200) {
        return this.$message.error('读取失败');
      }

      this.editForm = JSON.parse(res.data)[0].data[0];
      // console.log(this.editForm)
    },
    async updatejuese() {
      this.$refs.editFormRef.validate(async valid => {
       // if (!valid) return this.$message.error('验证错误！');
        const { data: res } = await this.$http.post('api', {
          C_type: 'juese_update',
          juese_uid: this.editForm.juese_uid,
          juese_name: this.editForm.juese_name,
          juese_type: this.editForm.juese_type
        });
        console.log(2)
        if (JSON.parse(res.data)[0].status !== 200) {
          this.$message.error('更新失败');
          return;
        }
        this.$message.success('更新成功');
        this.getJueseList();
        this.editDialogVisible = false;
      });
    },
    // 删除一条记录
    async deleteForm(jueseUid) {
      // 此处通过异步获取操作行为，而不用then ，来避免异步嵌套
      // 异步操作有2个，1个对话框等待，1个是网络请求
      const comfirmResult = await this.$confirm(
        '确定删除该条记录, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err);
      // console.log(comfirmResult);
      if (comfirmResult === 'cancel') return this.$message.info('已经取消删除');
      const { data: res } = await this.$http.post('api', {
        C_type: 'record_delete',
        C_table_name: 'juese_del',
        C_data1: jueseUid
      });
      if (JSON.parse(res.data)[0].status !== 200) {
        this.$message.error('删除失败');
        return;
      }
      this.$message.success('删除成功');
      this.getJueseList();
    },
    async removeRightById(quanxianUid) {
      // 此处通过异步获取操作行为，而不用then ，来避免异步嵌套
      // 异步操作有2个，1个对话框等待，1个是网络请求
      const comfirmResult = await this.$confirm(
        '确定删除该条权限, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err);
      // console.log(comfirmResult);
      if (comfirmResult === 'cancel') return this.$message.info('已经取消删除');
      const { data: res } = await this.$http.post('api', {
        C_type: 'record_delete',
        C_table_name: 'quanxian_del',
        C_data1: quanxianUid
      });
      if (JSON.parse(res.data)[0].status !== 200) {
        this.$message.error('权限删除失败');
        return;
      }
      this.$message.success('权限删除成功');
      this.getJueseList();
      // jueseList.children = res.data
    }
  }
};
</script>
<style lang="less" scoped>
.card_two {
  margin-top: 30px;
  box-shadow: none !important;
}

.el_row_two {
  margin-top: 30px;
}

.wai_row_buttom {
  margin-top: 30px;
  //  border-top: 1px solid #ddd;

  background-color: #f8f8f8;
  top: 50%;
  padding: 10px;
}

.nei_row_buttom {
  margin-top: 10px;
}

.el-tag {
  margin: 7px;
}

.bdtop {
  border-top: 1px solid #ddd;
}

.bdbottom {
  border-bottom: 1px solid #ddd;
}

.vcenter {
  display: flex;
  align-items: center;
}
</style>
